import React from "react";
import { Link } from "react-router-dom";

/** "New project / <kind>": the way back to the chooser from either kind's page. */
export const NewProjectCrumb: React.FC<{ here: string }> = ({ here }) => (
  <>
    <Link to="/projects/new" className="text-ink-400 transition-colors hover:text-ink-200">
      New project
    </Link>
    <span className="text-ink-400">/</span>
    <span className="truncate font-medium text-ink-100">{here}</span>
  </>
);
